import React from 'react'
import {
  IntlShape,
  LinkGroupMany,
  LinkGroups,
  LinkGroupSingle,
  NavRoute, SideNavLinkGroupFn,
  TitleMessage,
  User,
} from '@platform/cj-platform-navigation'
import { MDIcon } from '@cjdev-internal/visual-stack-x/MDIcon'
import messages from './messages'


const createPlatformRoute = (path: string, titleMessage: TitleMessage, Content: React.ElementType, allowedRoutes: string[] = []): NavRoute => {
  const isAllowed = (...paths: string[]) => paths.some(p => allowedRoutes.includes(p))

  const createLinkGroups: SideNavLinkGroupFn = (user: User, _location: Location, _intl: IntlShape) => {

    const homeGroup: LinkGroupSingle = {
      label: 'Home',
      HeaderIcon: () => (<MDIcon icon={'home'} size={18} />),
      isCurrentArea: path === '/',
      link: '/'
    }

    const commissionAdminToolGroup: LinkGroupMany = {
      label: 'Commission Admin Tool',
      HeaderIcon: () => (<MDIcon icon={'file-arrow-left-right'} size={18} />),
      isCurrentArea: path.includes('/commission-request') || path.includes('/commission-result'),
      links: [
        {
          label: 'Correction Request',
          path: '/commission-request',
          isCurrentPage: path.includes('/commission-request') || path === '/'
        },
        {
          label: 'Correction Results',
          path: '/commission-result',
          isCurrentPage: path.includes('/commission-result')
        }
      ]
    }

    const alternatePayeeGroup: LinkGroupSingle = {
      label: 'Alternate Payees',
      HeaderIcon: () => (<MDIcon icon={'bank-check'} size={18} />),
      isCurrentArea: path.includes('/alternate-payee'),
      link: '/alternate-payee'
    }

    const payoutResultsGroup: LinkGroupSingle = {
      label: 'Payout Results',
      HeaderIcon: () => (<MDIcon icon={'cash-check'} size={18} />),
      isCurrentArea: path.includes('/payout-results'),
      link: '/payout-results'
    }

    const links = [
      homeGroup,
      ...(isAllowed('/alternate-payee') ? [alternatePayeeGroup] : []),
      ...(isAllowed('/commission-request', '/commission-result') ? [commissionAdminToolGroup] : []),
      ...(isAllowed('/payout-results') ? [payoutResultsGroup] : []),
    ]

    return {
      areaLabel: messages.areaLabel.defaultMessage,
      groups: links
    }
  }

  return ({
    path,
    titleMessage,
    Content: () => {
      return (
        <Content />
      )
    },
    sideNavLinkGroups: createLinkGroups
  })
}
export default createPlatformRoute



